module.exports = __webpack_public_path__ + "img/full-speech_bubble2.6df5ebec.png";